import Lightbox from "./Lightbox";
import {transformImage} from "../../utils/StoryblokService";
import Image from "next/image";
import React from "react";
import {IStoryblokImage} from "../../types/IStoryblokImage";
import classNames from "classnames";

export default function GalleryImage(props: { el: IStoryblokImage, imagesize: string, shadow: boolean, lightbox: boolean }) {

    const [isShowing, setIsShowing] = React.useState(false);
    const el = props.el;

    return <>
        {props.lightbox &&
            <Lightbox isShowing={isShowing}
                      onClose={() => setIsShowing(false)}
            >
                <img
                    src={transformImage(el.filename, "1600x0")}
                    className={"w-full"}
                    alt={el.title}
                    onClick={() => setIsShowing(true)}
                />

                <p className={"font-bold text-center my-4"}>
                    {el.name}
                </p>
            </Lightbox>
        }
        <div
            key={el.id}
            className={"md:col-span-1"}><Image
            src={transformImage(el.filename, props.imagesize || "800x800")}
            className={classNames({
                "w-full rounded-lg ": true,
                "shadow": props.shadow,
                "cursor-pointer": props.lightbox
            })}
            alt={el.alt}
            onClick={() => {
                if (props.lightbox) {
                    setIsShowing(true)
                }
            }}
            width={800}
            height={800}
        />
            {el.name &&
            <p className={"text-gray-600 italic text-center my-4"}>
                {el.name}
            </p>}
        </div>
    </>
}